import { DataCache, DataCacheCollection, QueryResultsRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';
import { ScheduleGridResponse } from 'data/models/ScheduleGrid';
import { ScheduleGridUpdateResponse } from 'data/models/ScheduleGridUpdateResponse';

export class ScheduleGridCache extends DataCache {
    ScheduleGridResponses = PCCollection(ScheduleGridResponse);
    ScheduleGridUpdateResponses = new DataCacheCollection(ScheduleGridUpdateResponse, ScheduleGridUpdateResponse.update, i => 0, i => 0, { expectEmptyIds: true });

    constructor(data : PCCache) { 
        super(); 

        new QueryResultsRelationship(this.ScheduleGridResponses,       data.BerthClosures,               r => r.BerthClosures);
        new QueryResultsRelationship(this.ScheduleGridResponses,       data.BerthReservations,           r => r.BerthReservations);
        new QueryResultsRelationship(this.ScheduleGridResponses,       data.ItineraryPoints,             r => r.ItineraryPoints);
        new QueryResultsRelationship(this.ScheduleGridResponses,       data.PortCalls,                   r => r.PortCalls);
        new QueryResultsRelationship(this.ScheduleGridResponses,       data.UnlistedBerthReservations,   r => r.UnlistedReservations);
        new QueryResultsRelationship(this.ScheduleGridResponses,       data.Vessels,                     r => r.Vessels);
        new QueryResultsRelationship(this.ScheduleGridUpdateResponses, data.BerthClosures,               r => r.BerthClosures);
        new QueryResultsRelationship(this.ScheduleGridUpdateResponses, data.BerthReservations,           r => r.BerthReservations);
        new QueryResultsRelationship(this.ScheduleGridUpdateResponses, data.ItineraryPoints,             r => r.ItineraryPoints);
        new QueryResultsRelationship(this.ScheduleGridUpdateResponses, data.PortCalls,                   r => r.PortCalls);
        new QueryResultsRelationship(this.ScheduleGridUpdateResponses, data.UnlistedBerthReservations,   r => r.UnlistedReservations);
        new QueryResultsRelationship(this.ScheduleGridUpdateResponses, data.Vessels,                     r => r.Vessels);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/schedulegrid/cache.ts